import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portal-enterprise',
  templateUrl: './portal-enterprise.component.html',
  styleUrls: ['./portal-enterprise.component.scss']
})
export class PortalEnterpriseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
